import React from 'react'
import { FormControl } from 'react-bootstrap'

export default class Input extends React.Component {
  onChange(target) {
    let value = target.value
    value = target.files[0]

    this.setState({ value })
    this.props.onChange(this.props.property, value)
  }

  renderInput() {
    const { type, value, accept} = this.props
    let inputValue = value

    return <FormControl type={type} accept={accept} value={inputValue} onChange={e => this.onChange(e.target)} />
  }

  render() {
    return (
      <div>{this.renderInput()}</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Input.js